(function(){
'use strict';

/**
 * This is a wrapper around the /frs-api/csrf-token endpoint.
 *
 * It ensures that a CSRF token is fetched and set in the cookie during page initialization.
 *
 * This token will have been saved in the session on the server, so we can verify
 * it later against that same csrf cookie.
 *
 * @param $log
 * @param $http
 */
scCsrfTokenService.$inject = ["$log", "$http"];
function scCsrfTokenService($log, $http) {
  'use strict';

  var fetchCsrfToken = function fetchCsrfToken() {
    return $http.get('/frs-api/csrf-token').then(function (response) {
      return response && response.data && response.data.success ? response.data : undefined;
    }).catch(function (error) {
      // Log the error but don't fail completely
      $log.error('Failed to fetch CSRF token:', error);
      return undefined;
    });
  };

  return {
    fetchCsrfToken: fetchCsrfToken
  };
}

angular.module('classy').service('scCsrfTokenService', scCsrfTokenService);
})();